<template>
  <div class="highlight__box py-5 px-3">
    <b-form name="consultation" method="POST" data-netlify="true" data-netlify-honeypot="bot-field" @submit.prevent="handleSubmit">
      <p>Request a free consultation</p>
      <input type="hidden" name="form-name" value="consultation" />
      <b-form-group id="input-group-1" label-for="input-1">
        <b-form-input
            id="input-1"
            v-model="form.firstname"
            required
            name="firstname"
            placeholder="Enter name"
        >
        </b-form-input>
      </b-form-group>
      <b-form-group id="input-group-2" label-for="input-2">
        <b-form-input
            id="input-2"
            v-model="form.lastname"
            required
            name="lastname"
            placeholder="Enter surname"
        >
        </b-form-input>
      </b-form-group>
      <b-form-group
          id="input-group-3"
          description="We'll never share your email."
      >
        <b-form-input
            id="input-3"
            v-model="form.email"
            type="email"
            required
            name="email"
            placeholder="Enter email"
        >
        </b-form-input>
      </b-form-group>
      <b-form-checkbox
          id="checkbox-1"
          v-model="form.policy"
          name="checkbox-1"
          value="accepted"
          unchecked-value="not_accepted"
      >
        I read and accept the Growth Labs Terms of Service and Privacy Policy
      </b-form-checkbox>
      <b-button variant="primary" type="submit" v-b-modal.formModal class="mt-3">Submit</b-button>
    </b-form>
    <b-modal id="formModal" ok-only>
      <b-row>
        <b-col md="12" class="text-center d-flex flex-column justify-content-center">
          <div>
            <font-awesome-icon
                :icon="['fas', 'check-circle']"
                size="3x"
                class="mb-3"
            />
            <p>
              Thank you for reaching out! <br/>
              We'll process your request within 24 hours.
            </p>
          </div>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "ConsultationForm",
  data () {
    return {
      contactStep: 'ContactDetails',
      form: {
        firstname: '',
        lastname: '',
        email: '',
        policy: ''
      },
    }
  },
  methods: {
    encode(data) {
      return Object.keys(data)
          .map(
              key => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`
          )
          .join("&");
    },
    handleSubmit(e) {
      fetch("/", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: this.encode({
          "form-name": "consultation",
          ...this.form
        })
      })
        .then(() => {
          console.log('Success!')
        })
        .catch(() => {
          console.log('Fail!')
        });
    }
  }
}
</script>

<style scoped lang="scss">
  p {
    color: $dark-blue;
    font-size: 18px;
    font-weight: 500;
  }
  svg {
    color: $light-blue;
  }
</style>